<template>
  <svg class="svg-icon" aria-hidden="true">
    <use :xlink:href="`#svgicon-${iconClass}`" />
  </svg>
</template>
<script>
export default {
  props: {
    iconClass: { type: String, required: true }
  }
};
</script>
<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  fill: currentColor; /* 通过 CSS 控制颜色 */
}
</style>
